@if (canRemove) {
<a (click)="remove.emit()">
  <icon type="mat_remove_circle" color="red"></icon>
</a>
} @if (canAdd) {
<a (click)="add.emit()">
  <icon type="mat_add_circle" color="blue"></icon>
</a>
}
